import { render, staticRenderFns } from "./KeyFrameDetails.vue?vue&type=template&id=846ede4a&scoped=true&"
import script from "./KeyFrameDetails.vue?vue&type=script&lang=js&"
export * from "./KeyFrameDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846ede4a",
  null
  
)

export default component.exports